import { render, staticRenderFns } from "./CampoDocumento.vue?vue&type=template&id=5cbff5cf&scoped=true&"
import script from "./CampoDocumento.vue?vue&type=script&lang=js&"
export * from "./CampoDocumento.vue?vue&type=script&lang=js&"
import style0 from "./CampoDocumento.vue?vue&type=style&index=0&id=5cbff5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbff5cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbff5cf')) {
      api.createRecord('5cbff5cf', component.options)
    } else {
      api.reload('5cbff5cf', component.options)
    }
    module.hot.accept("./CampoDocumento.vue?vue&type=template&id=5cbff5cf&scoped=true&", function () {
      api.rerender('5cbff5cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/campos/CampoDocumento.vue"
export default component.exports